// extracted by mini-css-extract-plugin
export default {"readingPaneContainer":"GyLLa","readingPaneContainer--shown":"VCPYn"};